import React from "react";
import { Typography } from "antd";

interface IProps {
  tabKey: string;
}

export default ({ tabKey }: IProps) =>
  tabKey === "all" ? (
    <Typography.Text>
      Welcome to watchlist section. This is defaut watchlist which contains all stocks in selected country/exchange.
      <br />
      <Typography.Text>You may create new watchlist and set alert limit to monitor your target stocks.</Typography.Text>
    </Typography.Text>
  ) : (
    <Typography.Text code>
      There are two main features: wathclist & alert limits. Watchlist is a set of stock collections based on your
      interest.
    </Typography.Text>
  );
